import { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CopyableFieldProps {
  label: string;
  value: string;
}

export const CopyableField: React.FC<CopyableFieldProps> = ({ label, value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex items-center justify-between gap-2 py-1">
      <div className="min-w-0 flex-1">
        <span className="text-xs text-muted-foreground">{label}</span>
        <p className="text-sm font-mono truncate">{value}</p>
      </div>
      <button
        onClick={handleCopy}
        className="flex-shrink-0 p-1 rounded hover:bg-muted transition-colors"
        title={copied ? "Copied!" : "Copy to clipboard"}
      >
        {copied ? (
          <Check className="h-3.5 w-3.5 text-green-500" />
        ) : (
          <Copy className="h-3.5 w-3.5 text-muted-foreground" />
        )}
      </button>
    </div>
  );
};
